import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { MatCardModule } from "@angular/material/card";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { CertificadoService } from "app/service/certificado/certificados.service";
import { CertificadoValidacaoDTO } from "models/certificado-validacao";

@Component({
    selector: "app-validar-certificado",
    standalone: true,
    imports: [CommonModule, MatCardModule, RouterModule],
    templateUrl: "./validar-certificado.component.html",
    styleUrls: ["./validar-certificado.component.scss"],
})
export class ValidarCertificadoComponent implements OnInit {
    loading = true;
    valido = false;
    erroMsg: string | null = null;

    dados?: CertificadoValidacaoDTO;

    constructor(private route: ActivatedRoute, private certificadoService: CertificadoService) { }

    ngOnInit(): void {
        const param = this.route.snapshot.paramMap.get("idParticipacaoSessao");
        const id = param ? Number(param) : NaN;

        if (!param || Number.isNaN(id)) {
            this.marcarInvalido("Identificador inválido.");
            return;
        }

        this.certificadoService.validar(id).subscribe({
            next: (dto: any) => {
                const dEntrada = this.parseLocalDateTime(dto?.horaEntrada);
                const dSaida = this.parseLocalDateTime(dto?.horaSaida);

                const horaEntradaStr = dEntrada ? this.formatDateTimeBr(dEntrada) : "-------------";
                const horaSaidaStr = dSaida ? this.formatDateTimeBr(dSaida) : "-------------";
                const cargaHoraria =
                    dEntrada && dSaida
                        ? this.calcularCargaHoraria(dEntrada, dSaida) // vê opções A/B abaixo
                        : "-------------";

                this.dados = {
                    nomeParticipante: dto?.nomeParticipante ?? "-------------",
                    nomeSessao: dto?.nomeSessao ?? "-------------",
                    horaEntrada: horaEntradaStr,
                    horaSaida: horaSaidaStr,
                    cargaHoraria,
                    // usado pelo seu template
                    horaParticipacao: dEntrada ? this.formatDateBr(dEntrada) : "-------------",
                };

                this.valido = true;
                this.loading = false;
            },
            error: err =>
                this.marcarInvalido(
                    err?.status === 404 ? "Certificado não encontrado." : "Não foi possível validar o certificado.",
                ),
        });
    }

    private marcarInvalido(msg: string) {
        this.valido = false;
        this.loading = false;
        this.erroMsg = msg;
        this.dados = {
            nomeParticipante: "-------------",
            nomeSessao: "-------------",
            horaEntrada: "-------------",
            horaSaida: "-------------",
            cargaHoraria: "-------------",
            horaParticipacao: "-------------",
        };
    }

    private parseLocalDateTime(value: unknown): Date | null {
        if (!value) return null;

        if (typeof value === "string") {
            const d = new Date(value);
            return isNaN(d.getTime()) ? null : d;
        }

        if (Array.isArray(value)) {
            const [y, m, d, hh = 0, mm = 0, ss = 0, nanos = 0] = value as number[];
            const ms = Math.round((nanos || 0) / 1_000_000);
            return new Date(y, (m ?? 1) - 1, d ?? 1, hh, mm, ss, ms);
        }

        return null;
    }

    private formatDateTimeBr(d: Date): string {
        const dd = String(d.getDate()).padStart(2, "0");
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const yyyy = d.getFullYear();
        const HH = String(d.getHours()).padStart(2, "0");
        const MM = String(d.getMinutes()).padStart(2, "0");
        return `${dd}/${mm}/${yyyy} ${HH}:${MM}`;
    }

    private calcularCargaHoraria(entrada: Date, saida: Date): string {
        const diffMs = saida.getTime() - entrada.getTime();
        if (!isFinite(diffMs) || diffMs < 0) return "-------------";

        const totalMin = Math.floor(diffMs / 60000);
        const h = Math.floor(totalMin / 60);
        const m = totalMin % 60;
        return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
    }

    private formatDateBr(d: Date): string {
        const dd = String(d.getDate()).padStart(2, "0");
        const mm = String(d.getMonth() + 1).padStart(2, "0");
        const yyyy = d.getFullYear();
        return `${dd}/${mm}/${yyyy}`;
    }
}
